import Box from "./Box";

const Divider = ({ color, vertical, ...props }) => {
  if (vertical) {
    return <Box bg={color} height="100%" width="1px" {...props} />;
  }

  return <Box bg={color} height="1px" width="100%" {...props} />;
};

Divider.defaultProps = {
  color: "rgba(0,0,0,0.1)"
};

export default Divider;
